import { render } from "./GlobalSearch.vue?vue&type=template&id=c2f9e762"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"

import "./GlobalSearch.vue?vue&type=style&index=0&id=c2f9e762&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/globalSearch/GlobalSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2f9e762"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2f9e762', __exports__)) {
    console.log('reload')
    api.reload('c2f9e762', __exports__)
  }
  
  module.hot.accept("./GlobalSearch.vue?vue&type=template&id=c2f9e762", () => {
    console.log('re-render')
    api.rerender('c2f9e762', render)
  })

}


export default __exports__